// extracted by mini-css-extract-plugin
export default {"card":"StaffInfo_card__XRkiG","item":"StaffInfo_item__aagL-","itemActive":"StaffInfo_itemActive__JPaE9","switch":"StaffInfo_switch__7cSyd","title":"StaffInfo_title__lNxt-"};